import ReplacementLinksOverview from "./ReplacementLinksOverview"
import SkusInformationOverview from "./SkusInformationOverview"
import CollectionsInformationOverview from "./CollectionsInformationOverview"
import { DisplayLifecycleStagesSelector } from "../../status/DisplayCompaniesByLifeCycleStage"

const OrgsDataOverview = () => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div className="flex flex-col gap-4">
        <DisplayLifecycleStagesSelector />
        <SkusInformationOverview />
      </div>
      <ReplacementLinksOverview />
      <CollectionsInformationOverview />
    </div>
  )
}

export default OrgsDataOverview
